// extracted by mini-css-extract-plugin
export default {"departments":"VE-z","departmentHeading":"WE-z","departmentSection":"XE-z","departmentName":"YE-z","departmentLink":"ZE-z","expandIcon":"_E-z"};